import type {UseFormReturn} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {Input} from '@/components/ui/input';
import type {MedicationForm} from '@/services/graphqlHooks';

import type {ResidentMedicationBasicFormValues} from '../../utils/medicationFormInputs';
import MedicationUnitSelect from './MedicationUnitSelect';

export type MedicationAsNeededFieldsProps = {
  form: UseFormReturn<ResidentMedicationBasicFormValues>;
  selectedMedicationForm?: MedicationForm;
};

function MedicationAsNeededFields({
  form,
  selectedMedicationForm,
}: MedicationAsNeededFieldsProps) {
  const {t} = useTranslation();

  return (
    <div className="flex gap-4 max-sm:flex-col">
      <FormField
        control={form.control}
        name="asNeededQuantity"
        render={({field}) => (
          <FormItem className="grow basis-0">
            <FormLabel required>{t('Quantity')}</FormLabel>
            <FormControl>
              <Input
                {...field}
                type="text"
                value={field.value ?? ''}
                onChange={event =>
                  field.onChange(
                    event.target.value === '' ? undefined : event.target.value
                  )
                }
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="asNeededUnit"
        render={({field}) => (
          <FormItem className="grow basis-0">
            <FormLabel required>{t('Unit')}</FormLabel>
            <FormControl>
              <MedicationUnitSelect
                onChange={field.onChange}
                selectedMedicationForm={selectedMedicationForm}
                value={field.value ?? ''}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}

export default MedicationAsNeededFields;
